

exports.onInitialClientRender = () => {
  console.log('ReactDOM.render has executed')

  window.___HAS_LOADED = true
}
